
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useArxivSearch } from './arxiv/hooks/useArxivSearch';
import ArxivSearchForm from './arxiv/ArxivSearchForm';
import ArxivResultsList from './arxiv/ArxivResultsList';
import ArxivDirectImport from './arxiv/ArxivDirectImport';

const ArxivBatchFetch = () => {
  const {
    searchParams,
    setSearchParams,
    records,
    resumptionToken,
    loading,
    hasSearched,
    isFromCache,
    cacheWindow,
    handleSearch,
    handleLoadMore
  } = useArxivSearch();

  return (
    <div className="space-y-6">
      <Tabs defaultValue="bulk-search" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="bulk-search">Bulk Search</TabsTrigger>
          <TabsTrigger value="direct-import">Direct Import</TabsTrigger>
        </TabsList>
        
        <TabsContent value="bulk-search" className="space-y-6">
          <ArxivSearchForm
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            onSearch={() => handleSearch()}
            loading={loading}
            records={records}
            isFromCache={isFromCache}
            cacheWindow={cacheWindow}
          />

          <ArxivResultsList
            hasSearched={hasSearched}
            records={records}
            resumptionToken={resumptionToken}
            loading={loading}
            onLoadMore={handleLoadMore}
          />
        </TabsContent>
        
        <TabsContent value="direct-import">
          <ArxivDirectImport />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ArxivBatchFetch;
